'use client';

import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { type FragmentType, getFragmentData } from '@packages/gql/generated/shopping';
import { AplusFragmentFragmentDoc } from '@packages/gql/generated/shopping/AplusFragmentFragmentDoc';
import { ToggleServiceProductDocument } from '@packages/gql/generated/shopping/ToggleServiceProductDocument';
import { useAuthMutation } from '@packages/shared/src/hooks/useAuthMutation/useAuthMutation';
import { transformBasketAplusToItems } from '@packages/modules/src/APlus/helper/transformBasketAplusToItems';
import { useAplusSelection } from '@packages/modules/src/APlus/hooks/useAplusSelection/useAplusSelection';
import { AplusAccordion } from '@packages/modules/src/APlus/AplusAccordion/AplusAccordion.client';

export const ServiceItems = ({
  aplusData,
  pli,
}: {
  aplusData: FragmentType<typeof AplusFragmentFragmentDoc>;
  pli: string;
}) => {
  const { locale } = useIntl();
  const [, toggleServiceProduct] = useAuthMutation(ToggleServiceProductDocument);

  const fragmentData = getFragmentData(AplusFragmentFragmentDoc, aplusData);
  const { items, currency } = useMemo(
    () => transformBasketAplusToItems(fragmentData.clusters),
    [fragmentData.clusters],
  );

  const { controlled, hasSaveError } = useAplusSelection({
    items,
    toggleService: (serviceUuid) => toggleServiceProduct({ locale, lineItemId: pli, serviceUuid }),
    setServiceCount: (serviceUuid, count) =>
      toggleServiceProduct({ locale, lineItemId: pli, serviceUuid, count }),
  });

  return (
    <AplusAccordion
      items={items}
      currency={currency}
      controlled={controlled}
      hasSaveError={hasSaveError}
    />
  );
};
